/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../common/currency';
import '../common/tender';
import '../common/entry_method';
import '../common/payment';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "paymentreporter": {
        "nested": {
          "service": {
            "nested": {
              "UnsuccessfulPayment": {
                "fields": {
                  "paymentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "billToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.paymentreporter.service.UnsuccessfulPayment.Status",
                    "id": 3,
                    "rule": "optional"
                  },
                  "authorizationTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "voidTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "authorizationMoney": {
                    "type": ".squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cardBrand": {
                    "type": ".squareup.common.tender.CardTenderType",
                    "id": 7,
                    "rule": "optional"
                  },
                  "panSuffix": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "cardEntryMethod": {
                    "type": ".squareup.common.PayWithSquareEntryMethod",
                    "id": 9,
                    "rule": "optional"
                  },
                  "offlinePayment": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "dataSource": {
                    "type": ".squareup.paymentreporter.service.UnsuccessfulPayment.DataSource",
                    "id": 11,
                    "rule": "optional"
                  },
                  "squareProduct": {
                    "type": ".squareup.common.payment.SquareProduct",
                    "id": 12,
                    "rule": "optional"
                  },
                  "felicaBrand": {
                    "type": ".squareup.common.tender.FelicaCard.FelicaBrand",
                    "id": 13,
                    "rule": "optional"
                  },
                  "createPaymentNote": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "paymentMethod": {
                    "type": ".squareup.paymentreporter.service.UnsuccessfulPayment.PaymentMethod",
                    "id": 15,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "AUTH": 0,
                      "DECLINE": 1,
                      "VOID": 2,
                      "EXPIRED": 3,
                      "PENDING": 4
                    }
                  },
                  "DataSource": {
                    "values": {
                      "QUEUEBERT": 1,
                      "SPOT": 2
                    }
                  },
                  "PaymentMethod": {
                    "values": {
                      "CARD": 0,
                      "BANK_TRANSFER": 1,
                      "TRUSTED_EXTERNAL_PARTNER": 2
                    }
                  }
                }
              },
              "UnsuccessfulPaymentsReportRequest": {
                "fields": {
                  "beginTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "endTime": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "includeStatus": {
                    "type": ".squareup.paymentreporter.service.UnsuccessfulPayment.Status",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "includeSquareProduct": {
                    "type": ".squareup.common.payment.SquareProduct",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "includePaymentMethod": {
                    "type": ".squareup.paymentreporter.service.UnsuccessfulPayment.PaymentMethod",
                    "id": 8,
                    "rule": "repeated"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 1
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2
                  },
                  "sellerInfo": {
                    "type": ".squareup.paymentreporter.service.SellerInfo",
                    "id": 7
                  }
                },
                "nested": {
                  "owner_id": {
                    "oneof": ["merchantToken", "unitToken", "sellerInfo"]
                  }
                }
              },
              "UnsuccessfulPaymentsReportResponse": {
                "fields": {
                  "unsuccessfulPayment": {
                    "type": ".squareup.paymentreporter.service.UnsuccessfulPayment",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "SellerInfo": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.UnsuccessfulPayment && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.UnsuccessfulPayment?.nested?.Status && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.UnsuccessfulPayment?.nested?.DataSource && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.UnsuccessfulPayment?.nested?.PaymentMethod && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.UnsuccessfulPaymentsReportRequest && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.UnsuccessfulPaymentsReportResponse && !$root.nested?.squareup?.nested?.paymentreporter?.nested?.service?.nested?.SellerInfo) {
  $root.addJSON(jsonData);
}

/**
 * Imported from beemo from:
 * https://github.com/squareup/java/blob/b8d889fd614daafece464214f97f57b58727058c/beemo/beemo-proto/src/main/proto/squareup/beemo/v2/reporting/unsuccessful_payments.proto#L23
 *
 * Only change is the removal of the deprecated SQUARE_WEB data source from the enum.
 *
 * SOURCE UnsuccessfulPayment @ squareup/paymentreporter/unsuccessful_payments.proto at 21:1
 */
export const UnsuccessfulPayment = $root.lookupType('squareup.paymentreporter.service.UnsuccessfulPayment');
fixType(UnsuccessfulPayment);
Builder.createAndAttachToType(UnsuccessfulPayment);
/**
 * Payment status represents the latest state of the payment.
 *
 * SOURCE Status @ squareup/paymentreporter/unsuccessful_payments.proto at 32:3
 */
UnsuccessfulPayment.Status = $root.lookupEnum('squareup.paymentreporter.service.UnsuccessfulPayment.Status').values;
/**
 * Note: beemo originally had `SQUARE_WEB` as an enum value here but we have removed it since
 * it was a deprecated value and the endpoint doesn't query Sq/Web.
 *
 * SOURCE DataSource @ squareup/paymentreporter/unsuccessful_payments.proto at 84:3
 */
UnsuccessfulPayment.DataSource = $root.lookupEnum('squareup.paymentreporter.service.UnsuccessfulPayment.DataSource').values;
/**
 * Payment method.
 *
 * SOURCE PaymentMethod @ squareup/paymentreporter/unsuccessful_payments.proto at 105:3
 */
UnsuccessfulPayment.PaymentMethod = $root.lookupEnum('squareup.paymentreporter.service.UnsuccessfulPayment.PaymentMethod').values;
/**
 * Originally imported from beemo's protos:
 * https://github.com/squareup/java/blob/b8d889fd614daafece464214f97f57b58727058c/beemo/beemo-proto/src/main/proto/squareup/beemo/v2/reporting/unsuccessful_payments.proto#L89-L114
 *
 * Notable changes:
 *   - Did not bring over batch support (that was deprecated and unused).
 *   - Did not bring over the `request_params` field: that's a beemo type that defines many fields
 *     which beemo does not actually support on this report (and that we don't want to support).
 *     Instead copied the few fields we care about into the request itself.
 *   - Changed the merchant_token + subunit_merchant_token list fields to a oneof (of either
 *     merchant_token or unit_token). The endpoint only supported a single unit token (it returned
 *     a validation error if more than one was passed by the client) and we don't need a merchant
 *     token if the unit token is provided.
 *
 * SOURCE UnsuccessfulPaymentsReportRequest @ squareup/paymentreporter/unsuccessful_payments.proto at 134:1
 */
export const UnsuccessfulPaymentsReportRequest = $root.lookupType('squareup.paymentreporter.service.UnsuccessfulPaymentsReportRequest');
fixType(UnsuccessfulPaymentsReportRequest);
Builder.createAndAttachToType(UnsuccessfulPaymentsReportRequest);
/**
 * Imported from Beemo:
 * https://github.com/squareup/java/blob/b8d889fd614daafece464214f97f57b58727058c/beemo/beemo-proto/src/main/proto/squareup/beemo/v2/reporting/unsuccessful_payments.proto#L116-L121
 *
 * Only change is that we've dropped the `next_batch_token` since that's deprecated and was unsupported anyway.
 *
 * SOURCE UnsuccessfulPaymentsReportResponse @ squareup/paymentreporter/unsuccessful_payments.proto at 173:1
 */
export const UnsuccessfulPaymentsReportResponse = $root.lookupType('squareup.paymentreporter.service.UnsuccessfulPaymentsReportResponse');
fixType(UnsuccessfulPaymentsReportResponse);
Builder.createAndAttachToType(UnsuccessfulPaymentsReportResponse);
/**
 * Seller information to scope a request to.
 *
 * SOURCE SellerInfo @ squareup/paymentreporter/unsuccessful_payments.proto at 183:1
 */
export const SellerInfo = $root.lookupType('squareup.paymentreporter.service.SellerInfo');
fixType(SellerInfo);
Builder.createAndAttachToType(SellerInfo);